<!-- <p>location-tracker works!</p>
<div class="tracker-container">
    <h2>Live Location Tracker</h2>
    <div class="coordinates">
      <p><strong>Latitude:</strong> {{ latitude }}</p>
      <p><strong>Longitude:</strong> {{ longitude }}</p>
    </div>
    <div id="map" style="width: 100%; height: 400px;"></div>
  </div>
   -->

   <!-- <div>
    <h2>Live Location Tracker</h2>
    <div id="map" style="height: 500px; width: 100%;"></div>
  </div> -->
  <!-- <div>
    <h2>Live Location Tracker</h2>
    <div id="map" style="height: 500px; width: 100%;"></div>
    <p>
      Current Location: Latitude: {{ currentLocation.lat }}, Longitude: {{ currentLocation.lng }}
    </p>
  </div>
   -->

   <div>
    <h2>Live Location Tracker</h2>
    <div id="map" style="height: 500px; width: 100%;"></div>
    <p>
      Current Location: Latitude: {{ currentLocation.lat }}, Longitude: {{ currentLocation.lng }}
    </p>
  </div>
  